import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import Img from 'gatsby-image';

import { PostCard } from "./style"
import { getPostDate } from "../utils/date"

import samplePostCover from "../../images/posts/post-img.jpg"
import STAR from "../../assets/svg/star.svg"

const BlogCard = props => {
  const { summary, title, publishedAt, size, mainImage } = props
  const link = props.link

  return (
    <PostCard size={size}>
      <Link className="post_btn" to={link}>
      <h3>{title}</h3>
      </Link>
      <p className="date">{getPostDate(publishedAt).toString()}</p>
      <Img fluid={mainImage.asset.fluid ? mainImage.asset.fluid : samplePostCover} alt={title} />
      <p className="post_text">{summary}</p>
      {/* <div className="star_count">
        <STAR />
        <p>25</p>
      </div> */}
    </PostCard>
  )
}

export default BlogCard
